export default __webpack_public_path__ + "static/media/warrantyManagement3.ff9d7cc8.png";